import React from 'react';
import { ReactComponent as ConWxMetOceanLogo } from './conwx_metocean_logo.svg';

export default props => {
    const { className } = props;
    return <ConWxMetOceanLogo className={className} aria-label='ConWx MetOcean Logo'/>
}